export function parseEnGbDate(dateStr) {
  const [dd, mm, yyyy] = String(dateStr || '').split('/').map((p) => parseInt(p, 10));
  if (!dd || !mm || !yyyy) return null;
  const d = new Date(yyyy, mm - 1, dd);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function getWeekStart(d) {
  const date = new Date(d);
  const day = (date.getDay() + 6) % 7;
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() - day);
  return date;
}

export function getWeekKey(dateInput) {
  const date = typeof dateInput === 'string' ? parseEnGbDate(dateInput) : dateInput instanceof Date ? dateInput : null;
  if (!date) return null;

  const weekStart = getWeekStart(date);
  const thursday = new Date(weekStart);
  thursday.setDate(thursday.getDate() + 3);
  const isoYear = thursday.getFullYear();

  const jan4 = new Date(isoYear, 0, 4);
  const week1Start = getWeekStart(jan4);
  const diffDays = Math.round((weekStart - week1Start) / 86400000);
  const isoWeek = Math.floor(diffDays / 7) + 1;

  return `${isoYear}-W${isoWeek}`;
}

export function weekKeyToMonday(weekKey) {
  const [isoYear, isoWeek] = weekKey.split('-W').map(Number);
  const jan4 = new Date(isoYear, 0, 4);
  const week1Start = getWeekStart(jan4);
  const monday = new Date(week1Start);
  monday.setDate(monday.getDate() + (isoWeek - 1) * 7);
  return monday;
}

export function isConsecutiveWeeks(weekKeyA, weekKeyB) {
  const monA = weekKeyToMonday(weekKeyA).getTime();
  const monB = weekKeyToMonday(weekKeyB).getTime();
  return monB - monA === 7 * 86400000;
}

export function sortWeekKeys(weeks) {
  return [...weeks].sort((a, b) => weekKeyToMonday(a) - weekKeyToMonday(b));
}

export function getPreviousWeekKey(date = new Date()) {
  const weekStart = getWeekStart(date);
  weekStart.setDate(weekStart.getDate() - 7);
  return getWeekKey(weekStart);
}

function hasLoggedWork(workout) {
  return (workout?.exercises || []).some((ex) =>
    (ex.sets || []).some((s) => {
      if (s.completed === true) return true;
      if (s.completed === false) return false;
      return Boolean((s.reps && s.weight) || s.durationMinutes);
    })
  );
}

export function calcStreaks(workoutLog) {
  const finishedDates = Object.keys(workoutLog).filter((d) => workoutLog[d].finished || hasLoggedWork(workoutLog[d]));
  if (finishedDates.length === 0) return { current: 0, longest: 0 };

  const weeks = sortWeekKeys([...new Set(finishedDates.map(getWeekKey).filter(Boolean))]);
  if (weeks.length === 0) return { current: 0, longest: 0 };

  let longest = 1;
  let temp = 1;
  for (let i = 1; i < weeks.length; i++) {
    if (isConsecutiveWeeks(weeks[i - 1], weeks[i])) {
      temp++;
      longest = Math.max(longest, temp);
    } else {
      temp = 1;
    }
  }

  const now = new Date();
  const currentWeekKey = getWeekKey(now);
  const prevWeekKey = getPreviousWeekKey(now);
  const lastTrainedWeek = weeks[weeks.length - 1];

  let current = 0;
  if (lastTrainedWeek === currentWeekKey || lastTrainedWeek === prevWeekKey) {
    current = 1;
    for (let i = weeks.length - 2; i >= 0; i--) {
      if (isConsecutiveWeeks(weeks[i], weeks[i + 1])) {
        current++;
      } else {
        break;
      }
    }
  }

  return { current, longest };
}
